import { observable, action, runInAction, computed } from 'mobx'
import API from '@api/bi_nuo/liveManage'
import { message } from 'hljd'
import {
  liveLinkMicrophoneWait,
  liveLinkMicrophoneCancel,
  liveLinkMicrophoneStart,
  liveLinkMicrophoneStop,
  HOST_PAP
} from '../../constant'

export default class Store {
  constructor(id) {
    this.channel_id = id
  }
  // 初始化变量
  initData = () => {
    // 是否连麦、连麦礼
    this.getMicrophoneInfo()
    // 待接入users
    this.getMicrophoneUserList()
  }

  // 直播连麦
  @observable isLinkMicrophone = false
  @observable linkMicrophoneGift = ''
  @observable
  isLinkMicrophoneUser = {
    userId: '',
    nick: '暂无连线用户',
    avatar: '',
    status: '' //1: 待接入；2：已接入
  }

  @observable isLinkMicrophoneUsers = []
  @observable open = false
  // @observable showMore = false
  @observable useWSDataAble = false
  @observable linkSuccessUsersModalVisible = false
  /*
    [{
      nick: 'test1',
      userId: 1,
      id: 2,
      avatar: ""
    }]
    */
  @observable linkSuccessUsers = []

  @computed
  get showMore() {
    return this.isLinkMicrophoneUsers.length > 6
  }

  // 是否连麦、连麦礼
  @action
  getMicrophoneInfo = async () => {
    const { success, data = {} } = await API.getMicrophoneInfo({
      liveChannelId: this.channel_id || ''
    })
    if (success) {
      runInAction(() => {
        this.isLinkMicrophone = data.isopen == 1 //0：未连接；1：已连接
        this.linkMicrophoneGift = data.desc
      })
    }
  }

  // 处理web socket message
  @action
  handleWSData = _data => {
    // 当调用userList后，方可启用web socket数据
    if (!this.useWSDataAble) return

    const { msg_type, data = {} } = _data
    if (msg_type == 2) {
      //消息类型
      const { live_list = [], chat_room_list = [] } = data.message || {}
      const item =
        (live_list && live_list[0]) || (chat_room_list && chat_room_list[0])
      if (item) {
        const { msg_kind } = item
        const content = JSON.parse(item.content || '{}')
        const userId = content.id
        const nick = content.nick
        const avatar = content.avatar
        if (msg_kind == liveLinkMicrophoneWait) {
          //待接入
          /*  1、不在待接入数组
                  1.1 为当前用户，取消操作
                  1.2 非当前用户，执行后增
                2、在待接入数组，放弃操作
            */
          const it = this.isLinkMicrophoneUsers.find(
            item => item.userId == userId
          )
          if (!it) {
            if (userId != this.isLinkMicrophoneUser.userId) {
              this.isLinkMicrophoneUsers.push({
                nick,
                userId,
                avatar,
                status: 1
              })
            }
          }
        } else if (msg_kind == liveLinkMicrophoneStart) {
          //申请接入
          /*  1、是非为已接入用户，若是：取消操作，若非，执行第二步
                2、若为待接入用户，执行删除和替换当前接入人信息
            */
          if (userId != this.isLinkMicrophoneUser.userId) {
            const index = this.isLinkMicrophoneUsers.findIndex(
              item => item.userId == userId
            )
            if (index > -1) {
              this.isLinkMicrophoneUsers.splice(index, 1)
              this.isLinkMicrophoneUser = {
                userId,
                nick,
                avatar,
                status: 2
              }
            }
          }
        } else if (
          msg_kind == liveLinkMicrophoneCancel ||
          msg_kind == liveLinkMicrophoneStop
        ) {
          //已取消、已关闭
          /*  1、已接入用户，执行关闭
                2、非接入用户，执行删除
            */
          if (userId == this.isLinkMicrophoneUser.userId) {
            this.isLinkMicrophoneUser = {
              userId: '',
              nick: '暂无连线用户',
              avatar,
              status: ''
            }
          } else {
            const index = this.isLinkMicrophoneUsers.findIndex(
              item => item.userId == userId
            )
            if (index > -1) {
              this.isLinkMicrophoneUsers.splice(index, 1)
            }
          }
        }
      }
    }
  }

  // 待接入users
  @action
  getMicrophoneUserList = async () => {
    const { success, data } = await API.getMicrophoneUserList({
      liveChannelId: this.channel_id || ''
    })
    if (success) {
      runInAction(() => {
        this.useWSDataAble = true // 开始启用web socket监听数据
        this.filterMicrophoneUserList(data || [])
      })
    }
  }

  //过滤已接入用户
  @action
  filterMicrophoneUserList = data => {
    const index = data.findIndex(item => item.status == 2)
    if (index > -1) {
      this.isLinkMicrophoneUser = data[index] || this.isLinkMicrophoneUser //连麦中
      data.splice(index, 1) //剔除已连麦用户
    }
    this.isLinkMicrophoneUsers = data
  }

  //保存连麦状态、连麦礼
  @action
  changeLinkMicrophone = async v => {
    if (typeof v === 'boolean') {
      //更改连麦状态
      this.isLinkMicrophone = v
    }
    const params = {
      liveChannelId: this.channel_id || '',
      isopen: this.isLinkMicrophone ? '1' : '0',
      desc: this.linkMicrophoneGift || ''
    }
    const { success } = await API.microphoneSetInfo(params)
    if (success) {
      message.success('操作成功！')
    }
  }

  //连接成功名单modal
  @action
  showLinkSuccessUsersModal = () => {
    // 函数防抖
    clearTimeout(this.showLinkSuccessUsersTimer)
    let callNow = !this.showLinkSuccessUsersTimer
    this.showLinkSuccessUsersTimer = setTimeout(() => {
      this.showLinkSuccessUsersTimer = null
    }, 1000)
    if (callNow) {
      // 打开弹框时请求接口
      if (!this.linkSuccessUsersModalVisible) {
        // 请求连接成功名单接口
        this.getLinkSuccessUsers()
      }
      this.linkSuccessUsersModalVisible = !this.linkSuccessUsersModalVisible
    }
  }

  // 获取连接成功名单
  @action
  getLinkSuccessUsers = async () => {
    const { success, data } = await API.getLinkSuccessUsers({
      liveChannelId: this.channel_id
    })
    if (success) {
      runInAction(() => {
        this.linkSuccessUsers = data || []
      })
    }
  }

  //改变连麦礼
  @action
  changeLinkMicrophoneGift = e => {
    this.linkMicrophoneGift = e.target.value
  }

  //展开、收起
  @action
  changeOpen = () => {
    this.open = !this.open
  }

  // 连麦接入
  @action
  startLinkMicrophone = (item = {}, ws) => {
    const params = {
      msg_kind: liveLinkMicrophoneStart,
      client_message_id: 2,
      room_type: HOST_PAP,
      content: JSON.stringify({
        id: item.userId,
        nick: item.nick,
        avatar: item.avatar,
        status: item.status
      })
    }
    if (ws) {
      ws.send(JSON.stringify(params))
      this.isLinkMicrophoneUser = item //更新当前待联入用户
      const index = this.isLinkMicrophoneUsers.findIndex(
        _item => item.userId == _item.userId
      )
      if (index > -1) {
        //刷新待接入列表
        this.isLinkMicrophoneUsers.splice(index, 1)
      }
    }
  }

  // 连麦终止
  @action
  stopLinkMicrophone = (item = {}, ws) => {
    const params = {
      msg_kind: liveLinkMicrophoneStop,
      client_message_id: 2,
      room_type: HOST_PAP,
      content: JSON.stringify({
        id: item.userId,
        nick: item.nick,
        avatar: item.avatar,
        status: item.status
      })
    }
    if (ws) {
      ws.send(JSON.stringify(params))
      this.isLinkMicrophoneUser = {
        // 清空当前联入用户
        userId: '',
        nick: '暂无连线用户',
        avatar: '',
        status: ''
      }
    }
  }
}
